// @flow

import React from 'react';
import styled from 'styled-components';

const FramedText = styled.div`
  border: 3px solid #fff;
  padding: 0.3em 0.5em;
  font-size: 0.8em;

  text-transform: uppercase;
  font-weight: bold;
`;

const Text = styled.div`
  font-size: 0.95em;
`;

export const JuegoConResponsabilidad = (): React$Element<*> => (
  <FramedText>{'Juego Con Responsabilidad'}</FramedText>
);

export const NoHayJuego = (): React$Element<*> => <Text>{'Sin diversión no hay juego'}</Text>;
